module.exports = __webpack_public_path__ + "img/transparencia_three.0143925f.png";